"use client";

import { createContext, useContext, useRef } from "react";

const SharedAudioContext = createContext({ current: null });

/**
 * The one audio element persona speech plays through, rendered once in the
 * root layout so it exists on every page. Consumers read it from
 * useSharedAudioElement(); the id stays for readers not yet moved onto the ref.
 */
export function SharedAudioProvider({ children }) {
  const audioRef = useRef(null);
  return (
    <SharedAudioContext.Provider value={audioRef}>
      {children}
      <audio ref={audioRef} className="hidden" id="shared-audio-player" />
    </SharedAudioContext.Provider>
  );
}

/** A ref to the shared audio element; `.current` is null outside the provider. */
export const useSharedAudioElement = () => useContext(SharedAudioContext);
